import { styled } from "@mui/material/styles";
import { Container, Typography } from "@mui/material";

const StyledContainer = styled(Container)({
  width: "100%",
  height: "auto",
  padding: "100px 60px",
});

const AboutUsBottom = () => {
  return (
    <StyledContainer align="center">
      <Typography variant="large" align="center">
        Stick Your Face All Over the Place!
      </Typography>
    </StyledContainer>
  );
};

export default AboutUsBottom;
